import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
// import classnames from 'classnames';

// const PageTitle = ({ classes, ...props }) => (
//   <div className={classes.pageTitleContainer}>
//     <Typography className={classes.typo}>
//       {props.title}
//     </Typography>
//     {props.children}
//     {props.button && (
//       <Button
//         classes={{ root: classes.button }}
//         variant="contained"
//         size="large"
//         color="secondary"
//       >
//         {props.button}
//       </Button>
//     )}
//   </div>
// );

const PageTitle = ({ classes, ...props }) => (
  <div className={classes.pageTitleContainer}>
    <div className={props.button ? classes.wrapContent : classes.wrapContentWithOutButton}>
      <Typography className={classes.typo}>{props.title}</Typography>
      {props.children}
    </div>
    {props.button && <div className={classes.wrapButton}>{props.button}</div>}
  </div>
);

const styles = (theme) => ({
  pageTitleContainer: {
    background: 'white',
    margin: '-24px',
    padding: '36px 40px 7px 40px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  typo: {
    color: theme.palette.text.header,
    fontSize: '24px',
    padding: '4px',
    fontWeight: 500,
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
  },
  button: {
    boxShadow: theme.customShadows.widget,
    textTransform: 'none',
    '&:active': {
      boxShadow: theme.customShadows.widgetWide,
    },
  },
  wrapContent: {
    display: 'flex',
    width: '80%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  wrapContentWithOutButton: {
    display: 'flex',
    width: '100%',
  },
  wrapButton: {
    display: 'flex',
    width: '20%',
    justifyContent: 'end',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      justifyContent: 'start',
    },
  },
});

export default withStyles(styles)(PageTitle);
